import { render, staticRenderFns } from "./DossierEdit.vue?vue&type=template&id=584a889e&"
import script from "./DossierEdit.vue?vue&type=script&lang=ts&"
export * from "./DossierEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DossierEdit.vue?vue&type=style&index=0&id=584a889e&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584a889e')) {
      api.createRecord('584a889e', component.options)
    } else {
      api.reload('584a889e', component.options)
    }
    module.hot.accept("./DossierEdit.vue?vue&type=template&id=584a889e&", function () {
      api.rerender('584a889e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierEdit.vue"
export default component.exports